import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Camera, CameraResultType, CameraSource } from '@capacitor/camera';
import { ActionSheetController, ModalController } from '@ionic/angular';
import { ImageCropperComponent, ImageCroppedEvent, LoadedImage } from 'ngx-image-cropper';
import { appConfig } from 'src/app/config/app.config';
import { FdbService } from 'src/app/services/fdb.service';
import { FeedService } from 'src/app/services/modelService/feed.service';
import { StaticConstantsService } from 'src/app/services/staticConstants.service';
import { AlertService } from 'src/app/util/alert.service';
import { LoaderService } from 'src/app/util/loader.service';
import { UtilityService } from 'src/app/util/utility.service';
@Component({
  selector: 'app-attachment-display',
  templateUrl: './attachment-display.component.html',
  styleUrls: ['./attachment-display.component.scss'],
})
export class AttachmentDisplayComponent implements OnInit {
  @Input() attachmentUrl;
  @Output() attachmentUrlChange = new EventEmitter<string>();
  @Output() onUpload = new EventEmitter<string>();

  @Input() default;
  @Input() label = "Add attachment";
  @Input() refId;
  @Input() refType;
  @Input() path;
  @Input() canEdit;
  @Input() attachmentCssClass;
  @Input() type;
  @Output() onClick = new EventEmitter<any>();
  @Output() removeImage = new EventEmitter<any>();
  @ViewChild('myFile') fileElement: ElementRef;

  defaultAttachmentUrl: string;
  filename: string;
  utilityService: UtilityService = new UtilityService();
  isCropperModalOpen = false;
  imageChangedEvent: any = '';
  croppedImage: any = '';

  constructor(
    private actionSheetController: ActionSheetController,
    private alertService: AlertService, private feed: FeedService,
    private loader: LoaderService,
    public fdb: FdbService,
  ) { }

  ngOnInit() {
    switch (this.default) {
      case 'user':
        this.defaultAttachmentUrl = appConfig.DEFAULT_ATTACHMENT.USER;
        break;
      case 'logo':
        this.defaultAttachmentUrl = appConfig.DEFAULT_ATTACHMENT.LOGO;
        break;
      default:
        this.defaultAttachmentUrl = appConfig.DEFAULT_ATTACHMENT.DEFAULT;
    }
  }

  clickAttachment() {
    this.onClick.emit();
    if (this.type === 'OTHER') {
      this.openGallery();
    } else {
      this.selectImageType();
    }
  }

  openGallery() {
    if (this.attachmentUrl != null) {
      console.log("already there", this.attachmentUrl)
      if (this.attachmentUrl.mainurl) {
        window.open(this.attachmentUrl.mainurl, '_blank');
      } else {
        window.open(this.attachmentUrl, '_blank');
      }
    } else {
      this.fileElement.nativeElement.click();
    }
  }

  async onFileChange($event: any) {
    if (!$event.target.files || $event.target.files.length === 0) {
      alert('No image selected!');
      return;
    }
    const file = $event.target.files[0];
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      this.imageChangedEvent = reader.result;
      this.isCropperModalOpen = true;
    };
    reader.onerror = (error) => {
      console.error("Error reading file:", error);
      this.isCropperModalOpen = false;
    };
  }


  convertBlobToBase64(blob: Blob) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(blob);
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  }

  async imageCropped(event: any) {
    if (event.base64) {
      this.croppedImage = event.base64;
    } else if (event.blob) {
      this.croppedImage = await this.convertBlobToBase64(event.blob);
    }
  }


  loadImageFailed() {
    this.alertService.showAlert('Error', 'Image load failed.');
    this.isCropperModalOpen = false;
  }

  async saveCroppedImage(base64: string) {
    const pureBase64 = base64.split(",")[1];
    await this.calculateBase64Size(pureBase64);
    this.isCropperModalOpen = false;
    this.loader.show();
    this.fdb.uploadAnyFile(base64.split(",")[1], this.path + new Date().getTime() + ".jpg", base64.split(",")[0].split(":")[1]).then((url: string) => {
      this.loader.hide();
      this.onUpload.emit(url);
    });
  }
  openCropperModal(event: any) {
    this.imageChangedEvent = event;
    setTimeout(() => {
      this.isCropperModalOpen = true;
    }, 100);
  }

  deleteAttachment() {
    // this.alertService.showAlert("Remove Attachment", "Are you sure you want to delete ?").then(() => {
    //   this.fdb.deleteFromGCS(this.attachmentUrl).then((response) => {
    //     this.attachmentUrl = null;
    //     this.attachmentUrlChange.emit(null);
    //   });
    // })
  }

  async selectImageType() {
    if (StaticConstantsService.buildType == "BROWSER") {
      this.openGallery();
    } else {
      const actionSheet = await this.actionSheetController.create({
        header: 'Select image from',
        buttons: [{
          text: 'Gallery',
          icon: 'images',
          handler: () => {
            this.openGallery();
          }
        }, {
          text: 'Camera',
          icon: 'camera',
          handler: () => {
            this.takePicture();
          }
        }, {
          text: 'Cancel',
          icon: 'close',
          role: 'cancel',
          handler: () => {
            this.isCropperModalOpen = false;
            console.log('Cancel clicked');
          }
        }]
      });

      await actionSheet.present();
    }
  }

  async takePicture() {
    const image = await Camera.getPhoto({
      quality: 90,
      allowEditing: true,
      source: CameraSource.Camera,
      resultType: CameraResultType.DataUrl
    });

    this.imageChangedEvent = { target: { files: [this.dataURLtoFile(image.dataUrl, 'hello.' + image.format)] } };
    this.isCropperModalOpen = true;
  }

  dataURLtoFile(dataurl, filename) {
    var arr = dataurl.split(','),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[arr.length - 1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
  }

  removeAttachment() {
    this.removeImage.emit(this.attachmentUrl);
    this.attachmentUrl = null
  }

  private calculateBase64Size(base64String: string) {
    const padding = (base64String.endsWith("==") ? 2 : base64String.endsWith("=") ? 1 : 0);
    const sizeInBytes = (base64String.length * (3 / 4)) - padding;
    const sizeInBytesRounded = Math.round(sizeInBytes);
    const size = this.formatSize(sizeInBytesRounded);
    this.feed.lastImageSize = size;
    console.log("Image size:", this.feed.lastImageSize);
  }

  private formatSize(bytes: number) {
    const kb = bytes / 1024;
    const mb = kb / 1024;
    return {
      bytes: Math.round(bytes),
      kb: Number(kb.toFixed(2)),
      mb: Number(mb.toFixed(2))
    };
  }


}